import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { DialogConfig } from '../../dialog-config';
import { DialogRef } from '../../dialog-ref';

@Component({
  selector: 'rd-popup-leave-confirmation-dialog',
  templateUrl: './leave-confirmation-dialog.component.html',
  styleUrls: ['./leave-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LeaveConfirmationDialogComponent {
  @HostBinding('class.rd-popup-leave-confirmation-dialog')
  componentClass = true;

  constructor(
    private dialogRef: DialogRef,
    public dialogConfig: DialogConfig<{
      okClick: () => {};
      title: string;
      description: string;
      iconSymbol?: string;
      ok?: string;
      cancel?: string;
    }>,
  ) {}

  closeModal(): void {
    this.dialogRef.close();
  }

  okClick(): void {
    this.dialogConfig.data?.okClick();
    this.dialogRef.close();
  }

  get title(): string {
    return this.dialogConfig.data?.title ?? '';
  }

  get description(): string {
    return this.dialogConfig.data?.description ?? '';
  }

  get ok(): string {
    return (
      this.dialogConfig.data?.ok ?? 'offer.details.leave_confirmation_dialog.ok'
    );
  }

  get cancel(): string {
    return (
      this.dialogConfig.data?.cancel ??
      'offer.details.leave_confirmation_dialog.cancel'
    );
  }
}
